import { supabase } from '@/lib/supabase';
import { useAuthStore } from '@/stores/auth';
/**
 *ユーザーのカレンダリストを取得する
 * @param {Token} token アクセストークン
 * @returns {Array<id:String,title:String>} カレンダIDとタイトルの配列
 * 例: [{id: 'abc123', title: '仕事'}, {id: 'def456', title: 'プライベート'}]
 * 取得したIDを元にfetchCalendarEventsを呼び出すことで、各カレンダーのイベントを取得できます。
 */
export const fetchCalendarLists = async (token) => {
  console.log('カレンダーリスト取得開始...');
  // Google Calendar APIにアクセスしてユーザーのカレンダリストを取得
  const url = 'https://www.googleapis.com/calendar/v3/users/me/calendarList';
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // レスポンスをチェック
  let events = null;
  if (response.status === 401) {
    console.error(
      'アクセストークンが無効または期限切れです。リフレッシュトークンから新しいアクセストークンを取得します...',
    );
    // エラー時トークンを取得し直す
    events = await refreshAccessToken();
  } else {
    events = await response.json();
  }
  if (!events) {
    return [];
  }
  if (events.error) {
    return [];
  }
  console.log(events);
  const calMap = events?.items?.map((event) => ({
    id: event.id,
    title: event.summary,
    color: event.backgroundColor || '#4285f4', // カレンダーの背景色を使用（デフォルトはGoogleブルー）
  }));
  return calMap;
};

/**
 * Google Calendar API
 * @param {Token} token
 * @param {String} id カレンダーID
 * @param {Date} start 取得開始日時
 * @param {Date} end 取得終了日時
 * @returns
 */
export const fetchCalendarEvents = async (token, id, start, end) => {
  const param = `${encodeURIComponent(id)}/events?timeMin=${start.toISOString()}&timeMax=${end.toISOString()}&singleEvents=true&orderBy=startTime`;
  const url = `https://www.googleapis.com/calendar/v3/calendars/${param}`;
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const events = await response.json();
  return events;
};

/**
 * Googleの予定をEvent Calendar形式に変換
 * @param {Object} googleEvent
 * @returns
 */
export const mapGoogleEventToCalendar = (googleEvent) => {
  return {
    id: googleEvent.id,
    title: googleEvent.summary || '(無題)',
    resourceId: googleEvent.organizer?.email || 'default', // リソースIDは主催者のメールアドレスを使用

    start: googleEvent.start.dateTime || googleEvent.start.date,
    end: googleEvent.end.dateTime || googleEvent.end.date,
    extendedProps: { description: googleEvent.description || '(詳細なし)' },
  };
};

/**
 * リフレッシュトークンを利用してアクセストークンを取得する
 * @param {Token} refresh_token
 * @returns data
 */
export async function refreshAccessToken() {
  console.log(
    'アクセストークンが有効期限切れのため、リフレッシュトークンから新しいトークンを発行します',
  );
  // リフレッシュトークンを取得
  const { data: tokenData, error: tokenError } = await supabase
    .from('user_api_keys')
    .select('refresh_token')
    .eq('user_id', useAuthStore().user.id)
    .eq('provider', 'Google')
    .single();
  if (tokenError || !tokenData) {
    console.error('リフレッシュトークン取得失敗:', tokenError);
    return null;
  }
  const refresh_token = tokenData.refresh_token;
  console.log('リフレッシュトークン', refresh_token);

  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session) {
    console.error('ログインセッションがありません');
    return null;
  }

  // リフレッシュトークンを用いてsupabase Edge Functionを呼び出し、アクセストークンを取得する
  const { data: edgeData, error: edgeError } = await supabase.functions.invoke('token', {
    headers: {
      // Authorization: `Bearer ${import.meta.env.VITE_LOCAL_JWT_SECRET}`,
      Authorization: `Bearer ${session.access_token}`,
    },
    body: { refresh_token },
  });

  if (edgeError) {
    console.error('Edge Function 呼び出し失敗:', edgeError);
    return null;
  }

  return edgeData.access_token;
}
